import * as Yup from 'yup'

const createPatientNoteSchema = Yup.object().shape({
  note: Yup.string().required(),
  isHighPriority: Yup.boolean(),
})

export default createPatientNoteSchema
